import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-s3-buckets',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './s3-buckets.component.html',
  styleUrl: './s3-buckets.component.scss'
})
export class S3BucketsComponent {

}
